import React from 'react'
import FlatButton from '../../../components/buttons/flat_button'

interface SlideHeaderProps {
  title: string
  isEditing: boolean
  isUpdating: boolean
  isDirty?: boolean
  onUpdate: () => void
}

export const SlideHeader: React.FC<SlideHeaderProps> = ({
  title,
  isEditing,
  isUpdating,
  isDirty = true,
  onUpdate,
}) => {
  return (
    <div className="bg-main-green text-white px-6 py-4 flex justify-between items-center">
      <p className="text-xl font-bold">{title}</p>
      {isEditing && (
        <div className="bg-white rounded-md p-0.5">
          <FlatButton onClick={onUpdate} disabled={!isDirty || isUpdating}>
            このスライドを更新
          </FlatButton>
        </div>
      )}
    </div>
  )
}